<template>
  <div style="margin-bottom: 30px;">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home/index' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>{{$route.name}}</el-breadcrumb-item>
    </el-breadcrumb>
  </div>
  
  
</template>

<script>
  export default {
    name: 'crumb'
  }
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/crumb.vue